{
  "add_character": "Add character",
  "add_talent": "Add talent",
  "update_character": "Update character",
  "character_submit": "Submit character",
  "add_team": "Add team",
  "field_required": "This field is required",
  "title": "Title",
  "number": "number",
  "team_submit": "Submit team"
}
